import { FC } from "react";
import Section from "components/corphurusato/parts/Section";
import Headline, { Big, Sep } from "components/corphurusato/parts/Headline";
import StepBlock from "components/corphurusato/StepBlock";
import styled from "styled-components";
import Content from "components/corphurusato/parts/Content";

const DeductionFlow: FC = () => {
  return (
    <Section>
      <Headline color={"#6A0AA8"}>
        <Sep>寄附から</Sep>
        <Sep>
          <Big>税金控除</Big>までの流れ
        </Sep>
      </Headline>
      <Content>
        <StyledStepBlock label="応援したい自治体に寄附をする" color={"#6A0AA8"} step="01">
          <BlockContent>
            <StepImage src="/image/lp/corphurusato/deduction_flow/illust_01.png" alt="応援したい自治体に寄附をする" $height="64px" />
            <Paragraph>
              <StepSep>アニメファンドのサイトから</StepSep>
              <StepSep>気になるプロジェクトや自治体を検討します。</StepSep>
              <br />
              <StepSep>寄附金額シミュレーターを活用し、</StepSep>
              <StepSep>寄附金額を決め、寄附の手続きを行います。</StepSep>
            </Paragraph>
            <Annotation>
              <StepSep>※初めて企業版ふるさと納税を行う企業様が多いと思いますので、</StepSep>
              <StepSep>わからないことがあればまずはお問い合わせください。</StepSep>
            </Annotation>
          </BlockContent>
        </StyledStepBlock>
        <Arrow src="/image/lp/corphurusato/deduction_flow/arrow.png" />
        <StyledStepBlock label="自治体と今後の進め方を決める" color={"#6A0AA8"} step="02">
          <BlockContent>
            <StepImage src="/image/lp/corphurusato/deduction_flow/illust_02.png" alt="自治体と今後の進め方を決める" $height="100px" />
            <Paragraph>
              <StepSep>社会貢献PRの取り決めなどを自治体</StepSep>
              <StepSep>（アニメファンドがサポート）と決めます。</StepSep>
              <br />
              <StepSep>社会貢献PRの一切特典を受け取らず、</StepSep>
              <StepSep>寄附のみ行うことも可能です。</StepSep>
            </Paragraph>
          </BlockContent>
        </StyledStepBlock>
        <Arrow src="/image/lp/corphurusato/deduction_flow/arrow.png" />
        <StyledStepBlock label="受領証明書を受け取る" color={"#6A0AA8"} step="03">
          <BlockContent>
            <StepImage src="/image/lp/corphurusato/deduction_flow/illust_03.png" alt="受領証明書を受け取る" $height="98px" />
            <Paragraph>
              <StepSep>受領証明書が企業様あてに届きます。</StepSep>
              <br />
              <StepSep>青色申告の際に必要になりますので、</StepSep>
              <StepSep>大事に保管してください。</StepSep>
            </Paragraph>
            <Annotation>
              <StepSep>※マイページから送付先の変更も可能です。</StepSep>
            </Annotation>
          </BlockContent>
        </StyledStepBlock>
        <Arrow src="/image/lp/corphurusato/deduction_flow/arrow.png" />
        <StyledStepBlock label="税金の控除を受ける" color={"#6A0AA8"} step="04">
          <BlockContent>
            <StepImage src="/image/lp/corphurusato/deduction_flow/illust_04.png" alt="税金の控除を受ける" $height="98px" />
            <Paragraph>
              <StepSep>決算書作成時に、寄附分の</StepSep>
              <StepSep>「損金算入」「法人住民税の控除」</StepSep>
              <StepSep>「法人税の控除」「法人事業の控除」を行います。</StepSep>
            </Paragraph>
            <Annotation>
              <StepSep>例：決算期が3月末の場合3月末日までに振込などが完了していれば、</StepSep>
              <StepSep>当年の控除対処になります。</StepSep>
              <StepSep>（詳しくは、ご担当の税理士さんにご確認ください。）</StepSep>
            </Annotation>
          </BlockContent>
        </StyledStepBlock>
      </Content>
    </Section>
  );
};

export default DeductionFlow;

const StyledStepBlock = styled(StepBlock)``;

const Arrow = styled.img`
  display: block;
  margin: 20px auto;

  @media screen and (max-width: 960px) {
    width: 60%;
  }

  @media screen and (min-width: 961px) {
    width: 20%;
  }
`;

const BlockContent = styled.div`
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (min-width: 961px) {
    position: relative;
  }
`;

const StepImage = styled.img<{ $height: string }>`
  @media screen and (max-width: 960px) {
    width: 60%;
    max-width: 260px;
    max-height: 100px;
    object-fit: contain;
  }

  @media screen and (min-width: 961px) {
    position: absolute;
    right: 0;
    bottom: calc(50% - ${({ $height }) => $height} / 2 + 10px);
    height: ${({ $height }) => $height};
  }
`;

const Paragraph = styled.p`
  text-align: center;

  @media screen and (max-width: 960px) {
    margin: 10px 0;
  }
  @media screen and (min-width: 961px) {
    margin: 0 120px 5px;
  }
`;

const StepSep = styled(Sep)`
  margin-bottom: 0.7em;
`;

const Annotation = styled.p`
  text-align: center;

  @media screen and (max-width: 960px) {
    font-size: 11px;
  }

  @media screen and (min-width: 961px) {
    font-size: 12px;
    margin: 0 120px 5px;
  }
`;
